import React from 'react';

interface IProps {
  style?: any;
}

const AddColorIcon:React.FC<IProps> = (props: IProps) => {
  return (
    <svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1.5" y="1.5" width="44" height="44" rx="3.5" stroke="url(#paint0_linear_2040_37363)" strokeWidth="3"/>
        <path d="M33.9 25.1L25.1 25.1L25.1 33.9H22.9V25.1L14.1 25.1L14.1 22.9H22.9V14.1L25.1 14.1L25.1 22.9H33.9V25.1Z" fill="#AAA6A6"/>
        <defs>
        <linearGradient id="paint0_linear_2040_37363" x1="2.35" y1="-10.1833" x2="54.8333" y2="67.3667" gradientUnits="userSpaceOnUse">
        <stop offset="0.0477462" stop-color="#FA0404"/>
        <stop offset="0.244737" stop-color="#FBFF31"/>
        <stop offset="0.378571" stop-color="#EF00AC"/>
        <stop offset="0.606787" stop-color="#00DBCE"/>
        <stop offset="0.785502" stop-color="#4472E8"/>
        </linearGradient>
        </defs>
    </svg>
  )
}

export default AddColorIcon;